__turbopack_context__.v({
  "donorcount": "Btg11G_donorcount",
  "lastupdated": "Btg11G_lastupdated",
  "outputs": "Btg11G_outputs",
  "subheader": "Btg11G_subheader",
  "wrapper": "Btg11G_wrapper",
});
